var _path, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgOnfinalityIcon = function SvgOnfinalityIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 144,
    viewBox: "0 0 144 144",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M144 71.9991C144.04 82.9668 141.567 93.7978 136.772 103.66C131.977 113.523 124.987 122.155 116.338 128.894C107.689 135.633 97.6121 140.299 86.8804 142.534C76.1487 144.769 65.0478 144.514 54.4301 141.788V61.6133L79.9101 91.8901C81.6427 93.9508 83.9668 95.4285 86.5672 96.1229C89.1676 96.8172 91.9186 96.6946 94.447 95.7716C96.9754 94.8486 99.1589 93.1699 100.701 90.9631C102.244 88.7563 103.071 86.1283 103.07 83.4354V7.09322C115.318 12.946 125.661 22.1466 132.903 33.632C140.146 45.1173 143.993 58.4186 144 71.9991ZM64.0901 52.1181L89.5701 82.3948V2.21052C72.2648 -2.183 53.9449 0.0207405 38.1736 8.39312C22.4023 16.7655 10.3071 30.708 4.24059 47.5086C-1.82592 64.3093 -1.43005 82.7671 5.35121 99.2919C12.1325 115.817 24.8143 129.227 40.9301 136.915V60.5728C40.9292 57.8798 41.7561 55.2518 43.2987 53.045C44.8412 50.8383 47.0248 49.1596 49.5532 48.2365C52.0816 47.3135 54.8325 47.1909 57.433 47.8852C60.0334 48.5796 62.3575 50.0573 64.0901 52.1181Z",
    fill: "url(#paint0_linear_167_3)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_167_3",
    x1: 30.7401,
    y1: 130.952,
    x2: 113.321,
    y2: 13.0994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#031FEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#0326EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#032CED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.766097,
    stopColor: "#0DE5C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.876097,
    stopColor: "#0CFACA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#0CFACA"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOnfinalityIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Onfinality-Icon.54517d4a.svg";
export { ForwardRef as ReactComponent };